import React, { useState } from "react";
import {
  Avatar,
  Box,
  Typography,
  Chip,
  IconButton,
  Badge,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import styles from "./NotificationPage.module.css";
import announcement from "../../Main/components/NotificatonPopover/announcement.svg";
import { formatRelativeTime } from "../../../../components/Formatter/Formatter";
import moment from "moment";

interface CustomDropdownProps {
  item?: any;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({ item }) => {
  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        borderBottom: "1px solid #E5E7EB",
        p: 2,
        mb: 2,
        backgroundColor: open ? "rgba(102, 112, 133, 0.05)" : "#fff",
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <div
          key={item.id}
          className={`${styles.notificationPageItem} ${
            item.status === "ACTIVE" ? styles.unread : ""
          }`}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", gap: "10px" }}>
              <div>
                <Badge
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  color="primary"
                  overlap="circular"
                  badgeContent={item.status === "ACTIVE" ? <span /> : null}
                  variant={item.status === "ACTIVE" ? "dot" : "standard"}
                >
                  <Avatar
                    alt="avatar"
                    sx={{
                      width: "30px",
                      height: "30px",
                      background: "rgba(102, 112, 133, 0.11)",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={announcement}
                        width="20px"
                        height="20px"
                        alt="notification"
                      />
                    </Box>
                  </Avatar>
                </Badge>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <div
                  className={styles.itemHeading}
                  dangerouslySetInnerHTML={{
                    __html: item?.title,
                  }}
                />
                {item.status === "ACTIVE" && (
                  <div
                    style={{
                      padding: "1px",
                      border: "1px solid #11C89B",
                      backgroundColor: "#11C89B",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "8px",
                      width: "60px",
                      color: "#fff",
                    }}
                  >
                    New
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <Box display="flex" alignItems="center" gap={2}>
          <div className={styles.timeDisplay}>
            {formatRelativeTime(item.announcementDate)}
          </div>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
      </Box>

      {open && (
        <Box
          mt={2}
          pl={5}
          sx={{
            backgroundColor: "white",
            border: "1px solid #fff",
            padding: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* <div className={styles.email}>{item.description}</div> */}
          <div
            className={styles.email}
            dangerouslySetInnerHTML={{
              __html: item?.description,
            }}
          />
          <div className={styles.email}>
            {moment(item?.creationDate).format("DD/MM/YYYY")}
          </div>
        </Box>
      )}
    </Box>
  );
};

export default CustomDropdown;
